import React from 'react';
import { twMerge } from 'tailwind-merge';

interface ProfileAvatarProps {
  first_name: string;
  profile_id?: string;
  avatar_url?: string | null;
  className?: string;
  initials?: string;
}

const ProfileAvatar: React.FC<ProfileAvatarProps> = ({
  first_name,
  avatar_url,
  className = '',
  initials,
}) => {
  const fallbackLabel = (initials?.trim() || first_name.charAt(0) || '?').toString();

  return (
    <div
      className={twMerge(
        `w-12 h-12 rounded-full bg-[#EAF1F7] flex items-center justify-center text-secondary font-bold overflow-hidden`,
        className
      )}
    >
      {avatar_url ? (
        <img
          src={avatar_url}
          alt={first_name}
          className="w-full h-full object-cover object-top rounded-full"
        />
      ) : (
        <span>{fallbackLabel}</span>
      )}
    </div>
  );
};

export default ProfileAvatar;
